export default "__VITE_ASSET__C5VK44H8__"